export default "__VITE_ASSET__DJBqAwI0__"